// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__GJAA9","row":"Layout_row__Xrxf7","left_column":"Layout_left_column__SfS-R","left_column__wrapper":"Layout_left_column__wrapper__1D9to"};